/**
 * Pre-order Buy Supporters Button Handler
 * Updates product metafields when button is clicked
 */
class PreorderBuySupporters {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId;
    this.productPrice = parseFloat(button.dataset.productPrice) || 0;
    this.currentSupporters = parseInt(button.dataset.currentSupporters) || 0;
    this.currentTotal = parseFloat(button.dataset.currentTotal) || 0;
    
    this.button.addEventListener('click', (e) => this.handleClick(e));
  }
  
  async handleClick(e) {
    e.preventDefault();
    
    // Disable button during request
    this.button.disabled = true;
    this.button.textContent = '処理中...';
    
    try {
      // Calculate new values
      const newSupporters = this.currentSupporters + 1;
      const newTotal = this.currentTotal + this.productPrice;
      
      // Update metafields via API
      const success = await this.updateMetafields(newSupporters, newTotal);
      
      if (success) {
        // Update UI immediately
        this.updateUI(newSupporters, newTotal);
        
        // Show success message
        this.showMessage('応援購入が完了しました！', 'success');
        
        // Reload page after 1 second to sync with server
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        throw new Error('Failed to update metafields');
      }
    } catch (error) {
      console.error('Error updating pre-order:', error);
      this.showMessage('エラーが発生しました。もう一度お試しください。', 'error');
      this.button.disabled = false;
      this.button.textContent = '応援購入する';
    }
  }
  
  async updateMetafields(newSupporters, newTotal) {
    // Note: This requires a backend endpoint to update Shopify metafields
    // You'll need to create a Shopify app or use a custom endpoint
    
    try {
      // Option 1: Use a custom endpoint (requires backend setup)
      const response = await fetch('/apps/preorder/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          product_id: this.productId,
          current_supporters: newSupporters,
          current_total: newTotal
        })
      });
      
      if (response.ok) {
        return true;
      }
    } catch (error) {
      console.error('API call failed:', error);
    }
    
    // Option 2: Fallback - use form submission to trigger server-side update
    // This would require a custom Shopify app endpoint
    return false;
  }
  
  updateUI(newSupporters, newTotal) {
    // Update supporters count
    const supportersEl = document.querySelector('.preorder-supporters span');
    if (supportersEl) {
      supportersEl.textContent = ` ${newSupporters}人`;
    }
    
    // Update total amount
    const amountEl = document.querySelector('.preorder-amount .amount-value');
    if (amountEl) {
      // Format number with commas
      const formattedTotal = newTotal.toLocaleString('ja-JP');
      amountEl.textContent = formattedTotal;
    }
    
    // Update progress bar if exists
    const progressBar = document.querySelector('.preorder-progress-bar-fill');
    const progressLabel = document.querySelector('.preorder-progress-label');
    if (progressBar && progressLabel) {
      const targetAmount = parseFloat(document.querySelector('.preorder-target')?.textContent?.match(/[\d,]+/)?.[0]?.replace(/,/g, '') || 0);
      if (targetAmount > 0) {
        const percentage = (newTotal / targetAmount) * 100;
        const progressWidth = Math.min(percentage, 100);
        progressBar.style.width = `${progressWidth}%`;
        progressLabel.textContent = `${Math.round(percentage)}%`;
      }
    }
  }
  
  showMessage(message, type) {
    // Remove existing messages
    const existingMsg = document.querySelector('.preorder-message');
    if (existingMsg) {
      existingMsg.remove();
    }
    
    // Create message element
    const messageEl = document.createElement('div');
    messageEl.className = `preorder-message preorder-message--${type}`;
    messageEl.textContent = message;
    
    // Insert after button
    this.button.parentNode.insertBefore(messageEl, this.button.nextSibling);
    
    // Remove message after 3 seconds
    setTimeout(() => {
      messageEl.remove();
    }, 3000);
  }
}

// Initialize all buy supporters buttons
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.preorder-buy-supporters-btn');
  buttons.forEach(button => {
    new PreorderBuySupporters(button);
  });
});
